module.exports = __webpack_public_path__ + "images/smartphone-screen-1_bf0afc7414768fe95f4e36062c683541.png";